import React, { useState } from 'react';
import { Button, Checkbox, Link } from '@americanexpress/dls-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { addErrorToReport, addLogToReport } from '@americanexpress/one-app/ducks';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setPreferenceStatus } from '../../redux/privacy/action';
import { getEmail, getPreferenceStatus, getOriginalPreferenceStatus, getApplicationToken, getEnv } from '../../redux/selectors';
import { isMexicoMarketPathname } from '../../utils/ModuleMap';
import FormattedRichMessage from '../common/FormattedRichMessages';
import { updatePrivacyPreferences } from '../../services/privacy.service';
import PrivacyFlowLayout from './PrivacyFlowLayout';
import commonStyles from './styles/PrivacyFlow.scss';
import styles from './styles/Preference.scss';
const Preference = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [error, setError] = useState('');
  const email = useSelector(getEmail);
  const preferenceStatus = useSelector(getPreferenceStatus);
  const originalPreferenceStatus = useSelector(getOriginalPreferenceStatus);
  const appToken = useSelector(getApplicationToken);
  const activeLocale = intl.locale.toLowerCase();
  const env = useSelector(getEnv);
  const isChecked = preferenceStatus === 'O';
  const isMexicoMarket = isMexicoMarketPathname(activeLocale);
  const handleCheckboxChange = e => {
    const {
      checked
    } = e.target;

    // Checked → Opt-out → 'O'
    // Unchecked → Opt-in → 'I'
    const updatedStatus = checked ? 'O' : 'I';
    dispatch(setPreferenceStatus(updatedStatus));
  };
  const handleSubmit = async () => {
    try {
      let finalStatus = preferenceStatus;
      let shouldCallApi = true;

      // Case 1: No change made by user
      if (preferenceStatus === originalPreferenceStatus) {
        shouldCallApi = false;

        // Special case: original status is 'U' (first-time user)
        // Treat as opt-in ('I') but do not call API
        if (originalPreferenceStatus === 'U') {
          finalStatus = 'I';
        }
      }
      if (shouldCallApi) {
        const response = await updatePrivacyPreferences({
          emailAddress: email,
          preferenceStatus: finalStatus,
          // 'O' or 'I'
          appToken,
          env
        });
        if (response !== null && response !== void 0 && response.error) {
          await dispatch(addErrorToReport(response.error, response.errorData));
          setError('Failed to update preferences. Please try again.');
          return;
        }
        await dispatch(addLogToReport('info', 'privacy-update-success', response));
        if ((response === null || response === void 0 ? void 0 : response.responseCode) === 'SUCCESS') {
          navigate('/ipp/confirm');
        } else {
          setError('Failed to update preferences. Please try again.');
        }
      } else {
        // No change → skip API and go to confirmation
        navigate('/ipp/confirm');
      }
    } catch (errorCode) {
      const logs = {
        emailAddress: email,
        preferenceStatus,
        originalPreferenceStatus
      };
      await dispatch(addLogToReport('warn', 'privacy-update-catch', logs));
      await dispatch(addErrorToReport(errorCode, logs));
      setError('Something went wrong while updating preferences.');
    }
  };
  return /*#__PURE__*/React.createElement(PrivacyFlowLayout, null, /*#__PURE__*/React.createElement("h1", {
    className: `${commonStyles.title} color-text-brand-alt ${isMexicoMarket ? styles.centerTitle : ''}`
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "preference.title"
  })), /*#__PURE__*/React.createElement("p", {
    className: commonStyles.text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "preference.description"
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.optionsText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "preference.optionsFor",
    values: {
      email: /*#__PURE__*/React.createElement("span", {
        className: styles.email
      }, email)
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.checkboxWrapper
  }, /*#__PURE__*/React.createElement(Checkbox, {
    id: "checkbox-exclude-email",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preference.checkboxLabel",
      className: styles.checkalign
    }),
    checked: isChecked,
    onChange: handleCheckboxChange
  })), error && /*#__PURE__*/React.createElement("div", {
    className: commonStyles.errorMessage
  }, error), intl.messages['preference.additional'] && /*#__PURE__*/React.createElement("p", {
    className: commonStyles.text
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "preference.additional"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: handleSubmit,
    className: commonStyles.privacy_btn
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "preference.enterChanges",
    defaultMessage: "Enter Changes"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.returnLink
  }, /*#__PURE__*/React.createElement(Link, {
    href: `https://www.americanexpress.com/${activeLocale}/`
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "preference.returnHome"
  }))), intl.messages['preference.additional'] && /*#__PURE__*/React.createElement("p", {
    className: commonStyles.text
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "preference.additional"
  })), intl.messages['preference.additional2'] && /*#__PURE__*/React.createElement("p", {
    className: `${commonStyles.text} ${styles.additionalSmallText}`
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "preference.additional2"
  })));
};
export default Preference;